// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2HjVk","image":"Header_image__1g4Wb","name":"Header_name__13j_Q","info":"Header_info__3w7be","infoRow":"Header_infoRow__nhG5y"};